import { default as getOptions } from "@pb/utils/common/getOptions";
export const getVideoOptions = (isPlpVideo) => {
    return {
        accountId: getOptions(isPlpVideo ? 'videoPlp.accountIdPlp' : 'video.accountId'),
        playerId: getOptions(isPlpVideo ? 'videoPlp.playerIdPlp' : 'video.playerId'),
    };
};
//# sourceMappingURL=getVideoOptions.js.map